export default function designation(current_year) {
  switch (current_year) {
    case 1:
      return ("Webmaster")
    case 2:
      return ("Project Associate")
    case 3:
      return ("Project Leader")
    case 4:
      return ("Coordinator")
    case 5:
      return ("Emeritus Coordinator")
    default:
      return ("Emeritus Coordinator")
  }
}